module.exports = __webpack_public_path__ + "img/smart.e9455f4b.gif";